export default __webpack_public_path__ + "img/acff55100bb7404bf866aa3539719ef8.png";